import { handleActions } from 'redux-actions';
import { Map, fromJS } from 'immutable';
import actions from '@synergycms_app/store/actions';

const { customer } = actions;

//REDUCERS
export const currencies = handleActions(
  {
    [customer.currencies.get.toString()]: (currencies, { payload }) => {
      return fromJS(payload);
    }
  },
  Map()
);

export const main_currencies = handleActions(
  {
    [customer.mainCurrencies.get.toString()]: (mainCurrencies, { payload }) => {
      return fromJS(payload);
    }
  },
  Map()
);

export const current_currency = handleActions(
  {
    [customer.currentCurrency.set.toString()]: (currentCurrency, { payload }) => {
      return payload;
    }
  },
  String()
);
